const style1 = { 
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width:" 100%",
    maxWidth:"483px" // 480px
}
const style2 = { 
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = { 
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = { 
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"122.98137% 0 0 0", //"123.74999% 0 0 0",
    width:"100%"
}
const style5 = { 
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function ReaganRonaldEmbed(){
    return (
        <>
        <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/517721764" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/517721764?et=_Vq1BD-qQ0ppv6I9rgiICQ&tld=com&sig=3jQtpV2v9Zla9HSu71p589Ykqm-Rvr3Ga1_YsVpB5K8=&caption=true&ver=1" title="Ronald Reagan" scrolling="no" frameBorder="0" width="483" height="594" style={style5}></iframe></div></div>
        </>
    );
};
export default ReaganRonaldEmbed;

